/**
 * Find Space Journey State Management
 */
export default {
    namespaced: true,
    state: {
        visible: false,
        page: 'home',
        subpage: 'home',
        previousSubpage: null,
        item: null,
        public: false,
        userType: 'hirer'
    },
    getters: {
        visible (state) {
            return state.visible
        },
        page (state) {
            return state.page
        },
        subpage (state) {
            return state.subpage
        },
        item (state) {
            return state.item
        },
        public (state) {
            return state.public
        },
        previousSubpage (state) {
            return state.previousSubpage
        },
        userType (state) {
            return state.userType
        }
    },
    mutations: {
        show (state) {
            state.visible = true
        },
        hide (state) {
            state.visible = false
            state.page = 'home'
            state.subpage = 'home'
            state.public = false
            state.item = null
        },
        setPage (state, payload) {
            state.page = payload.page
        },
        setSubpage (state, payload) {
            state.item = payload.item ? payload.item : null
            state.previousSubpage = state.subpage
            state.subpage = payload.subpage
        },
        navigateToSubpage (state, payload) {
            state.item = payload.item ? payload.item : null
            state.visible = true
            state.page = payload.page
            state.previousSubpage = state.subpage
            state.subpage = payload.subpage
            state.public = payload.public ? payload.public : null
        },
        navigatePreviousSubpage (state, payload) {
            state.subpage = state.previousSubpage
            state.previousSubpage = 'home'
        },
        setItem( state, payload ) {
            state.item = payload.item ? payload.item : null
        },
        setUserType( state, payload) {
            state.userType = payload.userType ? payload.userType : 'hirer'
        }
    },
    actions: {

    }
}
